<template>
  <div class="survey-filter-container">
    <el-input
      clearable
      placeholder="Title"
      class="title-filter"
      v-model="surveyTitle"
      @clear="handleFilter"
      @input="handleDebounceFilter"
      @keyup.enter.native="handleFilter"
    ></el-input>
    <el-radio-group v-model="currentStatusFilter" style="margin-top: 1px">
      <el-radio-button :label="'ALL'">All</el-radio-button>
      <el-radio-button :label="'IS_ACTIVE'">Active</el-radio-button>
      <el-radio-button :label="'IS_INACTIVE'">Inactive</el-radio-button>
      <el-radio-button :label="'IS_PREVIEW'">Preview</el-radio-button>
    </el-radio-group>

    <el-button type="info" @click="handleFilter" plain>
      <i class="fa fa-fw fa-filter"></i> Filter
    </el-button>
  </div>
</template>
<script>
/* eslint-disable space-before-function-paren, func-names, prefer-arrow-callback */
import { debounce } from 'lodash';
import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

export default {
  name: 'SurveyFilter',
  data: () => ({
    surveyTitle: null,
    statusFilter: 'ALL',
  }),
  computed: {
    currentStatusFilter: {
      get() {
        return this.statusFilter;
      },
      set(status) {
        this.statusFilter = status;
        this.handleFilter();
      },
    },
    currentSurveyTitle: {
      get() {
        return this.surveyTitle;
      },
      set(title) {
        this.surveyTitle = title;
        this.handleFilter();
      },
    },
  },
  methods: {
    handleDebounceFilter: debounce(function() {
      this.handleFilter();
    }, 500),

    handleFilter() {
      const filters = {
        state: this.statusFilter,
        title: this.surveyTitle,
      };
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_SURVEY_FILTER}`, filters);
      this.$store.dispatch('surveybuilder/listSurveys', { filters });
    },
  },
};
</script>
<style lang="scss">
.survey-filter-container {
  display: inline-block;
  width: 100%;
}
.title-filter {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// SurveyFilter.vue?35d4fbbc